var $6746207c35f8a73d$exports = {};
$6746207c35f8a73d$exports = {
    "Empty": `Tuk\u{161}s`
};


export {$6746207c35f8a73d$exports as default};
//# sourceMappingURL=lv-LV.mjs.map
